import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import { fixTaxon, fixProduct, enhanceProducts, filterProducts, filterProductsByGroup } from '@/service/upgradeService'
import { dayjs, dayjsServer, formatServerSimple } from '@/helpers/dayjs'

export default {
	namespaced: true,
	state: {
		brand: '',
		channel: "",
		currentTaxon: "",
		categories: [],
		products: [],
		filters: [],
		productDetails: null,
		productReviews: null,
		currentProduct: null,
		loading: false,
		initialized: false,
		nextProductAvailablityChangeTime: null,
    menu: null,
		menuMode: false,
		menuChannel: config.DEFAULT_CHANNEL,
		menuTimedAvailability: false,
    publicMode: false,
    allergens: [
      'allergencelery',
      'allergencrustacean',
      'allergeneggs',
      'allergenfish',
      'allergengluten',
      'allergenlupin',
      'allergenmilk',
      'allergenmolluscs',
      'allergenmustard',
      'allergenpeanuts',
      'allergensesameseeds',
      'allergensoy',
      'allergensulphites',
      'allergentreenuts',
    ]
	},
	actions: {
		async loadProductList({ state, commit, getters, rootState, rootGetters }, { taxon, channel = null, shippingCode = null, getAll = false, accumulatorGroup = null } = { taxon: null }) {
			commit('setLoading', { item: true })
			let basketToken = null;

			if (state.menuMode) {
				state.channel = state.menuChannel ?? config.DEFAULT_CHANNEL
				shippingCode = config.MENU_SHIPPING_CODE;
			} else if (rootState.cart.serverData && !channel && !shippingCode) {
        // TODO: this access should be less based on serverdata
				state.channel = rootState.cart.serverData.channel.code
				basketToken = rootState.cart.basketToken
			} else {
        state.channel = channel ?? config.DEFAULT_CHANNEL
				shippingCode = shippingCode ?? config.PUBLIC_SHIPPING_CODE
        getAll = true
        commit('setPublicMode', { item: true })
			}

			if (taxon) {
				commit('setActiveCategory', {item: taxon})
			}

			// don't load products, if there is no channel, to prevent wrong prices or products.
			// this mostly applies to calls before the cart has been retrieved
			if (!state.channel) {
				commit('setLoading', { item: false })
				return;
			}
			try {

        let products = []
        if (!getters.useMenu) {
          const result = await service.products({ channel: state.channel, slug: state.currentTaxon, token: basketToken, shippingCode, getAll, accumulatorGroup, deliverTime: state.menuTimedAvailability ? formatServerSimple(dayjs()) : null })
          products = result?.items || []
        } else {
          const result = await service.menuProducts({ menu: state.menu?.id || 0, channel: state.channel, taxon: state.currentTaxon, tokenValue: basketToken, shippingCode, getAll, accumulatorGroup, deliverTime: state.menuTimedAvailability ? formatServerSimple(dayjs()) : null })
          products = result?.products || []
        }

				//map products
				let productList = products?.reduce?.((p, c) => {
					if (!c.variants || !c.variants.length) {
						return p;
					}
					let item = fixProduct(c);
					p.push(item)
					return p
				}, []) || []

				commit('setProducts', {item: productList})
			}
			catch(err) {
        commit('setProducts', {item: []})
			}
			commit('setLoading', { item: false })
      commit('setInitialized', { item: true })
		},
		async loadCategories({ state, commit, dispatch, getters, rootState, rootGetters }, { brand, channel = null, shippingCode = null, getAll = false, accumulatorGroup = null } = { brand: config.BRAND }) {
			let basketToken = null;

			if (state.menuMode) {
        state.channel = state.menuChannel ?? config.DEFAULT_CHANNEL;
				state.brand = brand;
				shippingCode = config.MENU_SHIPPING_CODE;
        commit('setPublicMode', { item: false })
			} else if (rootState.cart.serverData && !channel && !shippingCode) {
        // TODO: this access should be less based on serverdata
				state.channel = rootState.cart.serverData.channel.code
				state.brand = rootState.cart.serverData.channel.location.brand
				basketToken = rootState.cart.basketToken
        commit('setMenu', { item: null })
        commit('setPublicMode', { item: false })
			} else {
        state.channel = channel ?? config.DEFAULT_CHANNEL
				state.brand = brand;
				shippingCode = shippingCode ?? config.PUBLIC_SHIPPING_CODE
        getAll = true
        commit('setPublicMode', { item: true });
			}

      if (state.menuMode || state.publicMode) {
        const location = await dispatch('location/getLocation', { channel: state.channel }, { root: true })
        const menuId = location?.menus?.[shippingCode]

        if (menuId) {
          commit('setMenu', { item: { id: menuId } })
        }
      }

      let categoryList = []
      let categories = []
      let childCategories
      let productList = []
      if (!getters.useMenu) {
        const result = await service.taxons({ brand: state.brand, channel: state.channel, accumulatorGroup, shippingCode, getAll, token: basketToken, deliverTime: state.menuTimedAvailability ? formatServerSimple(dayjs()) : null })
        categories = fixTaxon(result.self).children
      } else {
        commit('setLoading', { item: true })
        const result = await service.menuTaxons({ menu: state.menu?.id || 0, channel: state.channel, accumulatorGroup, shippingCode, tokenValue: basketToken, getAll, deliverTime: state.menuTimedAvailability ? formatServerSimple(dayjs()) : null })
        categoryList = result?.taxons
          .map(taxon => fixTaxon(taxon))
          .sort((a, b) => a.position - b.position)
        categories = categoryList.filter(c => !c.childType)
        childCategories = categoryList.filter(c => ['extra', 'option'].includes(c.childType))
        productList = Object.values(result?.products).reduce((p, c) => {
          if (!c.variants || !c.variants.length) {
            return p;
          }
          let item = fixProduct(c);
          p.push(item)
          return p
        }, []) || []

        commit('setMenu', {item: result?.menu})
        commit('setProducts', {item: productList})
        dispatch('childproducts/setCategories', { categories: childCategories }, { root: true })
        commit('setLoading', { item: false })
        commit('setInitialized', { item: true })
      }

			let firstTaxon = categories[0]
			while (firstTaxon && firstTaxon.children.length > 0) {
				// search for the first cat
				firstTaxon = firstTaxon.children[0]
			}
			let firstCat = firstTaxon != null
				? firstTaxon.code
				: ''

			commit('setCategories', {item: categories})
			commit('setActiveCategory', {item: firstCat})
		},

		async loadNextProductAvailablityChangeTime ({ state, commit }, { accumulatorGroup = null }) {
			try {
				if (state.menuMode) {
					const result = await service.getNextProductAvailablityChangeTime({ channel: state.menuChannel, shippingCode: config.MENU_SHIPPING_CODE, accumulatorGroup })
					const time = result.nextTimeDependentChange
					if (time) {
						commit('setNextProductAvailablityChangeTime', { item: dayjsServer(time) })
					}
				}
			}
			catch {}
		},

		async readFilters({state, commit, dispatch}, { accumulatorGroup = null } = {}) {
			let data = []

			const result = await service.productTags({ channel: state.channel, accumulatorGroup })

			data = result.map(tag => ({
				id: tag.code,
				label: tag.name,
				active: false,
				group: '', // HACK: we do not have data to describe group
			}))

			commit('setFilters', {
				item: data
			})

		},

		async setFilter({state, commit}, {filterId, active}) {
			let filter = state.filters.find(f => f.id == filterId)
			if (filter) {
				filter.active = active
				commit('setFilterState', { item: filter})
			}
		},
		async getProductDetails({state, commit, rootState}, {code, accumulatorGroup = null}) {
			commit('setCurrentProduct', { item: code });
			commit('setProductDetails', { item: null });

      let basketToken = null;

			if (rootState.cart.serverData) {
				//TODO: this access should be less based on serverdata
				state.channel = rootState.cart.serverData.channel.code
				basketToken = rootState.cart.basketToken
			}

			try {
				const result = await service.productDetails({ slug: state.currentProduct, token: basketToken, channel: state.channel, accumulatorGroup })
				if (result) {
					const details = fixProduct(result);
					commit('setProductDetails', { item: details });
				}
			}
			catch(e) {
				throw e
			}
		},
		async getProductReviews({state, commit, rootState}, {code, accumulatorGroup = null}) {
			commit('setCurrentProduct', { item: code });
      commit('setProductReviews', { item: null });

      let basketToken = null;

			if (rootState.cart.serverData) {
				//TODO: this access should be less based on serverdata
				state.channel = rootState.cart.serverData.channel.code
				basketToken = rootState.cart.basketToken
			}

			try {
				const result = await service.productReviews({ slug: state.currentProduct, token: basketToken, channel: state.channel, accumulatorGroup })
				if (result) {
					result.code = state.currentProduct;

					commit('setProductReviews', { item: result });
				}
			}
			catch(e) {
				throw e
			}
		},
		async sendProductReview({state, dispatch, rootState}, {code, title, rating, comment, email, accumulatorGroup = null}) {
			const result = await service.sendProductReview({ slug: code, title, rating, comment, email, token: rootState.account.token, brand: state.brand || config.BRAND, accumulatorGroup })
			if (result) {
				dispatch('getProductReviews', { code })
			}
		},
		findOverviewTaxon({state, getters}, code) {
			const taxons = getters.categories.reduce((t, cat) => {
				if (cat.code == code) {
					return getters.categories;
				}
				const child = cat.children.find(child => child.code == code);

				if (child) {
					return cat.children;
				}

				return t
			}, [])

			return taxons.find((t, i) => i == 0 && t.virtualCategory);
		},
		setMenuMode({ commit }, { menuMode, menuChannel, menuTimedAvailability } = {}) {
			commit('setMenuMode', { item: !!menuMode });
			menuChannel && commit('setMenuChannel', { item: menuChannel });
			commit('setMenuTimedAvailability', { item: menuTimedAvailability })
		},
	},
	getters: {
		productsLoading(state) {
			return state.loading;
		},
		productsInitialized(state) {
			return state.initialized;
		},
		products(state) {
			return state.products ? state.products : []
		},
    productsEnhanced(state, getters, rootState, rootGetters) {
			return enhanceProducts(getters.products, rootGetters, true)
				.filter(filterProductsByGroup(rootGetters))
				.filter(filterProducts(rootGetters))
        .map(product => ({
          ...product,
          isCustomerExclusive: !!(product.customerGroups && product.customerGroups.length)
        }))
		},
		productsEnhancedTaxon(state, getters) {
			return getters.currentTaxonPath.at(-1)?.products
        ?.reduce((p, code) => {
          const product = getters.productsEnhanced.find(product => product.code === code)
          if (product) {
            p.push(product)
          }
          return p
        }, []) || []
		},
    productsCustomerExclusive(state, getters) {
      return getters.productsEnhanced.filter(product => product.isCustomerExclusive)
    },
		categories(state) {
      return state.categories ?? []
		},
    categoriesFiltered(state, getters) {
      if (getters.productsInitialized) {
        const categories = getters.categories

        if (getters.currentCategoriesHaveOverview && !getters.useMenu) {
          return categories.filter(c => {
            if (c.checkIfEmpty) {
              return getters.products.some(p => p.taxons.includes(c.code))
            }

            return true
          })
        }

        return categories
      }

      return []
    },
    productsEnhancedCategories(state, getters, rootState, rootGetters) {
			let products = getters.productsEnhanced
			let siblings = getters.useMenu ? getters.currentCategories : getters.currentCategorySiblings

			// return empty tree
			if (!products.length || !siblings.length) {
				return []
			}

			if (!getters.useMenu) {
				let map = siblings.reduce((p, c) => {
					p[c.code] = p[c.code] || []

					c.children?.forEach(child => {
						p[child.code] = p[child.code] || []
					})

					return p
				}, {})

				products.some((p, i) => {
					// reset special product
					p.special = false;

					Object.keys(map).forEach(cat => {
						if (p.taxons.includes(cat)) {
							map[cat].push(p)
						}
					})

					return false
				})

				return siblings.reduce((p, c) => {
					if (map[c.code]?.length || c.children?.some(cc => map[cc.code]?.length)) {
						let categoryProducts = map[c.code]

						// sort per category
						const currentTaxon = c.code
						categoryProducts.sort((a, b) => (a.taxonsSort[currentTaxon] != null ? a.taxonsSort[currentTaxon] : Number.MAX_VALUE) - (b.taxonsSort[currentTaxon] != null ? b.taxonsSort[currentTaxon] : Number.MAX_VALUE))

						const children = c.children?.reduce((children, child) => {
							if (map[child.code]?.length) {
								let categoryProducts = map[child.code]

								// sort per category
								const currentTaxon = child.code
								categoryProducts.sort((a, b) => (a.taxonsSort[currentTaxon] != null ? a.taxonsSort[currentTaxon] : Number.MAX_VALUE) - (b.taxonsSort[currentTaxon] != null ? b.taxonsSort[currentTaxon] : Number.MAX_VALUE))

								children.push({
									category: child,
									products: categoryProducts
								})

							}
							return children
						}, []) || []

						p.push({
							category: c,
							products: categoryProducts,
							children,
						})
					}
					return p
				}, [])
			}

			return siblings.reduce((p, c) => {
				if (c.products?.length || c.children?.some(cc => cc.products?.length)) {
					const children = c.children?.reduce((children, child) => {
						if (child.products?.length) {
							children.push({
								category: child,
								products: child.products?.reduce((a,p) => {
                  const product = products.find(pp => pp.code === p)
                  if (product) {
                    product.special = false
                    a.push(product)
                  }
                  return a
                }, [])
							})

						}
						return children
					}, []) || []

					p.push({
						category: c,
						products: c.products?.reduce((a,p) => {
              const product = products.find(pp => pp.code === p)
              if (product) {
                product.special = false
                a.push(product)
              }
              return a
            }, []),
						children,
					})
				}
				return p
			}, [])
		},
		hasSubCategories(state, getters) {
			return getters.categories.reduce((acc, cat) => {
				return !!cat.children.length || acc;
			}, false);
		},
		filters(state) {
			return state.filters
		},
		filtersActive(state) {
			return state.filters
				.filter(f => f.active)
				.map(f => f.id)
		},
		favoriteCode(state) {
			return 'favorite'
		},
		currentTaxon(state) {
			return state.currentTaxon
		},
		currentTaxonPath(state, getters) {
			let path = []
			const buildRecur = (categories, taxon, path) => {
				const res = categories.some(cat => {
					if (cat.code == taxon) {
						path.push(cat)
						return true
					} else if (cat.children) {
						let childRes = buildRecur(cat.children, taxon, path)
						if (childRes) {
							path.push(cat)
						}
					} else {
						return false
					}
				})
				return res
			}

			// build path deep first
			buildRecur(getters.categories, state.currentTaxon, path)

			// we have to revers the path because searchin
			path = path.reverse()

			return path
		},
		currentSubCategories(state, getters) {
			let path = getters.currentTaxonPath
			if (path.length > 0) {
				return path[0].children
			}
			return []
		},
		currentCategories (state, getters) {
			let currentTaxonPath = getters.currentTaxonPath
			let children = currentTaxonPath.length > 1 ? currentTaxonPath[currentTaxonPath.length - 2].children : getters.categories
			return children
		},
    showOverviewCategory(state) {
      return !!state.menu?.showOverviewCategory
    },
    currentCategorySiblings (state, getters) {
			let currentTaxon = getters.currentTaxon
			let currentTaxonPath = getters.currentTaxonPath
			let children = currentTaxonPath.length > 1 ? currentTaxonPath[currentTaxonPath.length - 2].children : getters.categories
			return children.filter(taxon => taxon.code != currentTaxon && taxon.virtualCategory !== true)
		},
		currentCategoryIsOverview (state, getters) {
			return getters.currentTaxonPath[getters.currentTaxonPath.length - 1]?.virtualCategory === true || false
		},
		currentCategoriesHaveOverview (state, getters) {
			if (getters.categories?.[0]?.virtualCategory) {
				return true
			}

			if (getters.hasSubCategories) {
				return getters.currentSubCategories?.[0]?.virtualCategory || false
			}

			return false
		},
		currentOverviewCategory (state, getters) {
			if (getters.currentCategoriesHaveOverview) {
				return getters.currentSubCategories[0] || getters.categories[0]
			}
		},
		currentOverviewCategoryIsTop (state, getters) {
			if (getters.currentOverviewCategory) {
				return !!getters.categories.find(cat => cat.code === getters.currentOverviewCategory.code)
			}
		},
		currentProduct(state) {
			return state.products.find(p => p.code == state.currentProduct);
		},
		currentProductDetails(state) {
			return state.productDetails;
		},
		currentProductReviews(state) {
			return {
        ...(state.productReviews || {}),
        reviews: (state.productReviews?.reviews || []).map(review => {
          return {
            ...review,
            date: dayjs(new Date(review.date)).format('L')
          }
        })
      };
		},
    publicMode(state) {
			return state.publicMode;
		},
		menuMode(state) {
			return state.menuMode;
		},
		productsMenu(state) {
      return state.menu?.id
    },
    useMenu(state, getters, rootState, rootGetters) {
      return ((rootGetters['cart/hasBasket'] && rootGetters['cart/cartMenu'] && !getters.menuMode && !getters.publicMode) || getters.productsMenu)
    },
		nextProductAvailablityChangeTime (state) {
			return state.nextProductAvailablityChangeTime
		},
    allergens(state) {
      return state.allergens
    }
	},
	mutations: {
		setActiveCategory: generateSetChild('currentTaxon'),
		setProducts: generateSetChild('products'),
		setCategories: generateSetChild('categories'),
		setFilters: generateSetChild('filters'),
		setFilterState: generateUpdateArrayChild('filters'),
		setLoading: generateSetChild('loading'),
		setInitialized: generateSetChild('initialized'),
		setProductDetails: generateSetChild('productDetails'),
		setProductReviews: generateSetChild('productReviews'),
		setCurrentProduct: generateSetChild('currentProduct'),
		setMenu: generateSetChild('menu'),
		setMenuMode: generateSetChild('menuMode'),
		setMenuChannel: generateSetChild('menuChannel'),
		setMenuTimedAvailability: generateSetChild('menuTimedAvailability'),
		setNextProductAvailablityChangeTime: generateSetChild('nextProductAvailablityChangeTime'),
		setPublicMode: generateSetChild('publicMode'),
	}
}
